module.exports = __webpack_public_path__ + "img/scene1-1.51302261.png";